/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Preprocessing_LabelInputs */

const en_ocr_preprocessing_label = /** @type {(inputs: Ocr_Preprocessing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enhance image for OCR`)
};

const fr_ocr_preprocessing_label = /** @type {(inputs: Ocr_Preprocessing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Améliorer l'image pour la reconnaissance optique de caractères (OCR)`)
};

const de_ocr_preprocessing_label = /** @type {(inputs: Ocr_Preprocessing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild für OCR optimieren`)
};

const it_ocr_preprocessing_label = /** @type {(inputs: Ocr_Preprocessing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Migliora l'immagine per l'OCR`)
};

const ru_ocr_preprocessing_label = /** @type {(inputs: Ocr_Preprocessing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Улучшение изображения для распознавания текста.`)
};

const es_ocr_preprocessing_label = /** @type {(inputs: Ocr_Preprocessing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejorar la imagen para OCR`)
};

const zh_cn2_ocr_preprocessing_label = /** @type {(inputs: Ocr_Preprocessing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`增强图像以利于OCR识别`)
};

const ja_ocr_preprocessing_label = /** @type {(inputs: Ocr_Preprocessing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR用に画像を補正する`)
};

const hi_ocr_preprocessing_label = /** @type {(inputs: Ocr_Preprocessing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR के लिए छवि को बेहतर बनाएं`)
};

const pt_pt2_ocr_preprocessing_label = /** @type {(inputs: Ocr_Preprocessing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprimorar imagem para OCR`)
};

/**
* | output |
* | --- |
* | "Enhance image for OCR" |
*
* @param {Ocr_Preprocessing_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_preprocessing_label = /** @type {((inputs?: Ocr_Preprocessing_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Preprocessing_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_preprocessing_label(inputs)
	if (locale === "de") return de_ocr_preprocessing_label(inputs)
	if (locale === "it") return it_ocr_preprocessing_label(inputs)
	if (locale === "ru") return ru_ocr_preprocessing_label(inputs)
	if (locale === "es") return es_ocr_preprocessing_label(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_preprocessing_label(inputs)
	if (locale === "ja") return ja_ocr_preprocessing_label(inputs)
	if (locale === "hi") return hi_ocr_preprocessing_label(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_preprocessing_label(inputs)
	return en_ocr_preprocessing_label(inputs)
});